import { Component, Inject, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-pop-over',
    templateUrl: './pop-over.component.html',
    styleUrls: ['./pop-over.component.scss']
})
export class PopOverComponent implements OnInit, OnChanges {
    start: number;

    constructor(public dialogRef: MatDialogRef<PopOverComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.start = this.data.start ? this.data.start : 1;
    }
    ngOnInit(): void {}
    ngOnChanges(changes: SimpleChanges): void {}
}
